import { p as o } from "./FormRichText.model-53e072ea.js";
import { openBlock as n, createElementBlock as i } from "vue";
import { _ as s } from "./_plugin-vue_export-helper-dad06003.js";
import "./_commonjsHelpers-10dfc225.js";
const a = {
  props: {
    markdown: {
      type: String,
      default: ""
    },
    linksBlank: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    html() {
      return o(this.markdown);
    }
  },
  mounted() {
    this.linksBlank && this.$nextTick(() => {
      this.$el.querySelectorAll("a").forEach((t) => {
        t.setAttribute("target", "_blank"), t.setAttribute("rel", "noopener noreferrer"), t.addEventListener("click", (e) => {
          e.stopPropagation();
        });
      });
    });
  }
}, l = ["innerHTML"];
function p(t, e, c, m, d, r) {
  return n(), i("div", { innerHTML: r.html }, null, 8, l);
}
const h = /* @__PURE__ */ s(a, [["render", p]]);
export {
  h as MarkdownHtml
};
